import { Box } from "@mui/material";
import { useStyles } from "./PriorityStock.styles";
import { PRIORITY_STOCK_FLAG_CONFIG } from "./constants";
import { PriorityStockFlagProps } from "./types";

export const PriorityStockFlag = ({ flag }: PriorityStockFlagProps) => {
	const classes = useStyles();
	const config = PRIORITY_STOCK_FLAG_CONFIG[flag];

	if (!config) {
		return null;
	}
	const { priorityClassName, Icon, iconProps } = config;

	return (
		<Box display="flex" className={`${classes.priorityStockFlagContainer} ${classes[priorityClassName]}`}>
			<Box className={classes.iconContainer}>
				<Icon {...iconProps} />
			</Box>
			<Box>{flag}</Box>
		</Box>
	);
};
